import { render } from "./roles-modal.vue?vue&type=template&id=626614c0"
import script from "./roles-modal.vue?vue&type=script&lang=js"
export * from "./roles-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__